import { Button, Stack, Text } from "@bookingcom/bui-react";
import { ArrowNavLeftIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";

interface AddAirlineHeaderProps {
  onBack: () => void;
}

export const AddAirlineHeader = ({ onBack }: AddAirlineHeaderProps) => {
  const i18n = useI18n();

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack gap={0}>
        <Text variant="headline_1">Add airline</Text>
        <Text variant="body_2" color="neutral_alt">
          Onboard a new airline to the portal
        </Text>
      </Stack>
      <Button variant="secondary" icon={ArrowNavLeftIcon} onClick={onBack}>
        {i18n.trans(t("flights_airline_portal_superuser_back_button"))}
      </Button>
    </Stack>
  );
};
